(() => {
  const ROOT_SELECTOR = '[data-vzy-tabs]';
  const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';
  const controllers = new WeakMap();

  const cleanText = (value) => value?.replace(/\s+/g, ' ').trim() || '';

  const prepareDescriptionImageNames = (descriptionBody) => {
      const productTitle = cleanText(document.querySelector('h1')?.textContent) || 'Produs VIZZYO';
      const nearbyDescription = (image) => {
        let node = image.closest('h2, h3, h4, p, div');
        for (let depth = 0; node && depth < 4; depth += 1, node = node.parentElement) {
          let sibling = node.previousElementSibling;
          for (let index = 0; sibling && index < 3; index += 1, sibling = sibling.previousElementSibling) {
            const text = cleanText(sibling.textContent);
            if (text.length >= 8 && text.length <= 140) return text;
          }
          sibling = node.nextElementSibling;
          for (let index = 0; sibling && index < 3; index += 1, sibling = sibling.nextElementSibling) {
            const text = cleanText(sibling.textContent);
            if (text.length >= 8 && text.length <= 140) return text;
          }
        }
        return '';
      };

      descriptionBody.querySelectorAll('img:not([alt]), img[alt=""]').forEach((image, index) => {
        const context = nearbyDescription(image);
        image.alt = index === 0 ? productTitle : `${productTitle} — ${context || 'detaliu al produsului'}`;
        image.dataset.vzyAutoAlt = 'true';
      });

  };

  const prepareDescriptionMediaFrames = (body) => {
    // Pasted paragraphs can open with the hero image and continue with text.
    // The image moves into its own paragraph, so the text joins the reading column.
    [...body.children].forEach((block) => {
      if (!block.matches('p') || !cleanText(block.textContent)) return;
      if (block.querySelectorAll('img, video, iframe').length !== 1) return;
      const image = block.querySelector('img');
      if (!image) return;
      const media = image.closest('picture') || image;
      for (let node = media.parentElement; node !== block; node = node.parentElement) {
        if (!node.matches('span, strong, b, em, i')) return;
      }
      const before = document.createRange();
      before.setStart(block, 0);
      before.setEndBefore(media);
      if (cleanText(before.toString())) return;
      const frame = document.createElement('p');
      block.before(frame);
      frame.appendChild(media);
      let lead = block.firstChild;
      while (lead && lead.nodeType === Node.TEXT_NODE && !lead.textContent.trim()) lead = lead.nextSibling;
      if (lead?.nodeName === 'BR') lead.remove();
    });

    [...body.children].forEach((block) => {
      if (!block.matches('p') || cleanText(block.textContent)) return;
      if (block.querySelectorAll('img').length !== 1) return;
      const wrappers = [...block.querySelectorAll('*')];
      if (wrappers.some((element) => !element.matches('img, picture, source, span, strong, b, em, i, a, br'))) return;
      block.classList.add('vzy-tabs-v2__media-frame');
    });
  };

  const normalizeText = (value) => cleanText(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[?!:.]+$/g, '')
    .trim();

  const isPackageHeading = (value) => {
    const heading = normalizeText(value);
    const patterns = [
      /^ce (?:se )?(?:afla|gasesti|primesti|contine) (?:in )?(?:pachet|cutie)$/,
      /^tot ce (?:gasesti|primesti) (?:in )?(?:pachet|cutie)$/,
      /^continut(?:ul)? (?:din )?(?:pachet(?:ului)?|cutiei?)$/,
      /^(?:pachet(?:ul)?|cutia) contine$/
    ];
    return patterns.some((pattern) => pattern.test(heading));
  };

  const isPackageContinuationHeading = (value) => {
    const heading = normalizeText(value);
    return [
      /^in (?:cutie|pachet) (?:primesti|gasesti|vei gasi)$/,
      /^cadou(?:ri)? incluse(?: in (?:cutie|pachet))?$/
    ].some((pattern) => pattern.test(heading));
  };

  const isLegacyBenefitsHeading = (value) => {
    const heading = normalizeText(value);
    return heading.startsWith('beneficii incluse automat in fiecare comanda')
      || heading.startsWith('beneficii incluse automat la fiecare comanda')
      || heading.startsWith('pentru a-ti oferi cea mai buna experienta');
  };

  const isLegacyBenefitsCopy = (value) => {
    const copy = normalizeText(value)
      .replace(/\p{Extended_Pictographic}\uFE0F?/gu, '')
      .trim();
    return isLegacyBenefitsHeading(copy)
      || copy.startsWith('cadou:')
      || copy.startsWith('livrare rapida si gratuita')
      || /^economisesti\s+[\d.,]+\s*lei\b/.test(copy);
  };

  const closestContentBlock = (element, container) => {
    let block = element.closest('h1, h2, h3, h4, h5, h6, p, li, blockquote, div');
    if (!block || block === container || !container.contains(block)) block = element;
    return block;
  };

  const prepareDescriptionSmartModules = (root) => {
    const descriptionBody = root.querySelector('[data-vzy-description-body]');
    const smartModules = root.querySelector('[data-vzy-smart-modules]');
    if (!descriptionBody || !smartModules) return;

    const smartModuleSections = [...smartModules.children].filter((child) => child.matches('section'));
    if (!smartModuleSections.length) {
      smartModules.remove();
      return;
    }

    const candidates = [...descriptionBody.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong, b')]
      .filter((element) => !smartModules.contains(element));
    const legacyHeading = candidates.find((element) => isLegacyBenefitsHeading(element.textContent || ''));
    const packageHeading = candidates.find((element) => isPackageHeading(element.textContent || ''));
    let insertionTarget = packageHeading ? closestContentBlock(packageHeading, descriptionBody) : smartModules;

    if (legacyHeading) {
      const startBlock = closestContentBlock(legacyHeading, descriptionBody);
      const packageBlock = packageHeading ? closestContentBlock(packageHeading, descriptionBody) : null;
      const marker = document.createComment('vzy-smart-modules');
      startBlock.before(marker);

      const contentBlocks = [...new Set(
        [...descriptionBody.querySelectorAll('h1, h2, h3, h4, h5, h6, p, li, blockquote, strong, b')]
          .filter((element) => !smartModules.contains(element))
          .map((element) => element.closest('h1, h2, h3, h4, h5, h6, p, li, blockquote') || element)
      )];
      const startIndex = Math.max(0, contentBlocks.indexOf(startBlock));
      const packageIndex = packageBlock ? contentBlocks.indexOf(packageBlock) : -1;
      const endIndex = packageIndex > startIndex ? packageIndex : contentBlocks.length;

      contentBlocks.slice(startIndex, endIndex).forEach((block) => {
        if (isLegacyBenefitsCopy(block.textContent || '')) block.remove();
      });

      descriptionBody.querySelectorAll('p:empty, li:empty, blockquote:empty').forEach((element) => element.remove());
      insertionTarget = marker;

      smartModuleSections.forEach((module) => insertionTarget.before(module));
      marker.remove();
    } else {
      smartModuleSections.forEach((module) => insertionTarget.before(module));
    }

    smartModules.remove();
    root.dataset.vzySmartModules = 'ready';
  };

  const isGiftSource = (item) => {
    if (/\bcadou\b/i.test(item.textContent || '')) return true;

    const list = item.closest('ul, ol');
    let sibling = list ? list.previousElementSibling : null;
    let checked = 0;
    while (sibling && checked < 3) {
      const text = normalizeText(sibling.textContent || '');
      if (text) return /^cadou(?:ri)?(?: incluse)?$/.test(text);
      sibling = sibling.previousElementSibling;
      checked += 1;
    }
    return false;
  };

  const cleanPackageText = (value, isGift) => {
    let packageText = value
      .replace(/\p{Extended_Pictographic}\uFE0F?/gu, '')
      .replace(/^\s*\d+[.)]\s*/, '')
      .replace(/^\s*cadou\s*:?\s*/i, '')
      .replace(/\s+/g, ' ')
      .replace(/\s+([,.;:!?])/g, '$1')
      .replace(/([,;:])(?=\S)/g, '$1 ')
      .replace(/\b(\d+)\s*GB\b/gi, '$1 GB')
      .replace(/\b2\s*[xX]\s+panouri solar\b/i, '2 panouri solare')
      .replace(/\bpanouri solar\b/gi, 'panouri solare')
      .replace(/\bPanou Solar\b/g, 'Panou solar')
      .replace(/\bClass 10\b/g, 'clasa 10')
      .replace(/\bincarcare\b/gi, 'încărcare')
      .replace(/\s+\+\s+/g, ' și ')
      .trim();

    if (isGift) {
      packageText = packageText
        .replace(/^primești gratuit\s+/i, '')
        .replace(/,\s*oferit cadou\s*,/i, ',')
        .trim();
    }

    return packageText.replace(/^([a-zăâîșț])/u, (character) =>
      character.toLocaleUpperCase('ro-RO')
    );
  };

  const iconTypeFor = (value) => {
    const packageText = normalizeText(value);
    if (/\bcamera\b/.test(packageText)) return 'camera';
    if (/\bpanou(?:ri)? solar(?:e)?\b|\blampa solar/.test(packageText)) return 'solar';
    if (/microsd|card (?:de )?memorie|\bcard tf\b/.test(packageText)) return 'memory';
    if (/cartela sim|\bsim 4g\b/.test(packageText)) return 'sim';
    if (/sticker|autocolant|zona supravegheata/.test(packageText)) return 'sticker';
    if (/manual|ghid de utilizare/.test(packageText)) return 'manual';
    if (/garantie|certificat/.test(packageText)) return 'warranty';
    if (/telecomand/.test(packageText)) return 'remote';
    if (/adaptor|alimentare|cablu|usb-c|incarcare/.test(packageText)) return 'power';
    if (/montaj|surub|diblu|surubelnita|suport de montaj/.test(packageText)) return 'tools';
    if (/etansare|protectie la apa|izolare impotriva apei/.test(packageText)) return 'protection';
    return 'package';
  };

  const createPackageIcon = (type) => {
    const namespace = 'http://www.w3.org/2000/svg';
    const definitions = {
      camera: [['path', { d: 'M4.5 7.5h2.2l1.1-2h8.4l1.1 2h2.2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z' }], ['circle', { cx: '12', cy: '13.5', r: '4' }]],
      solar: [['circle', { cx: '18', cy: '5', r: '2.5' }], ['path', { d: 'M18 1v1M18 8v1M14 5h-1M23 5h-1M15.2 2.2l-.7-.7M21.5 8.5l-.7-.7M20.8 2.2l.7-.7M14.5 8.5l.7-.7' }], ['rect', { x: '3', y: '10', width: '18', height: '10', rx: '1.5' }], ['path', { d: 'M3 15h18M8 10l-1 10M16 10l1 10' }]],
      memory: [['path', { d: 'M7 2.5h8l4 4v15H5v-17a2 2 0 0 1 2-2Z' }], ['path', { d: 'M9 2.5v5M12 2.5v5M15 2.5v5' }], ['rect', { x: '8', y: '13', width: '8', height: '5', rx: '1' }]],
      sim: [['path', { d: 'M8 2.5h7l4 4v15H5v-16a3 3 0 0 1 3-3Z' }], ['rect', { x: '8', y: '10', width: '8', height: '7', rx: '1' }], ['path', { d: 'M12 10v7M8 13.5h8' }]],
      sticker: [['rect', { x: '4', y: '3', width: '16', height: '18', rx: '2' }], ['path', { d: 'M12 7.5 8.5 14h7L12 7.5ZM12 10.5v1.8M12 15.8h.01' }]],
      manual: [['path', { d: 'M3.5 4.5h6a3 3 0 0 1 3 3v13a3 3 0 0 0-3-3h-6v-13ZM20.5 4.5h-6a3 3 0 0 0-3 3v13a3 3 0 0 1 3-3h6v-13Z' }]],
      warranty: [['path', { d: 'M12 2.5 20 6v5.5c0 4.6-3.1 8.1-8 10-4.9-1.9-8-5.4-8-10V6l8-3.5Z' }], ['path', { d: 'm8.5 12 2.2 2.2 4.8-4.8' }]],
      protection: [['path', { d: 'M12 2.5 20 6v5.5c0 4.6-3.1 8.1-8 10-4.9-1.9-8-5.4-8-10V6l8-3.5Z' }], ['path', { d: 'M12 8.5s-2.5 2.7-2.5 4.4a2.5 2.5 0 0 0 5 0C14.5 11.2 12 8.5 12 8.5Z' }]],
      tools: [['path', { d: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-8 8l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 8-8l-3.8 3.8Z' }]],
      power: [['path', { d: 'M9 2v6M15 2v6' }], ['path', { d: 'M6 8h12v3a6 6 0 0 1-12 0V8Z' }], ['path', { d: 'M12 17v5' }]],
      remote: [['rect', { x: '7', y: '2.5', width: '10', height: '19', rx: '2' }], ['circle', { cx: '12', cy: '7', r: '1.5' }], ['path', { d: 'M10 12h4M10 16h4' }]],
      package: [['path', { d: 'm3 7 9-4.5L21 7l-9 4.5L3 7Z' }], ['path', { d: 'M3 7v10l9 4.5L21 17V7M12 11.5v10M7.5 4.8l9 4.5' }]]
    };
    const svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    definitions[type].forEach(([tagName, attributes]) => {
      const element = document.createElementNS(namespace, tagName);
      Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
      svg.append(element);
    });
    return svg;
  };

  const enhancePackageContent = (root, packageContent) => {
    const listItems = [...packageContent.querySelectorAll('li')].filter(
      (item) => !item.parentElement.closest('li')
    );
    let sources = listItems;
    if (!sources.length) {
      sources = [...packageContent.querySelectorAll('p')].filter((paragraph) =>
        /^\s*\d+[.)]\s*/.test(paragraph.textContent || '')
      );
    }

    const items = sources
      .map((source) => {
        const isGift = isGiftSource(source);
        return { isGift, text: cleanPackageText(source.textContent || '', isGift) };
      })
      .filter((item) => item.text);
    if (!items.length) return false;

    const intro = document.createElement('div');
    const title = document.createElement('h4');
    const lead = document.createElement('p');
    const list = document.createElement('ul');
    intro.className = 'vzy-package-intro';
    title.className = 'vzy-package-title';
    lead.className = 'vzy-package-lead';
    list.className = 'vzy-package-list';
    title.textContent = root.dataset.packageContentHeading || 'Tot ce primești în pachet';
    lead.textContent = root.dataset.packageContentLead || 'Componentele și accesoriile incluse, prezentate clar pentru o instalare rapidă.';
    intro.append(title, lead);

    items.forEach((item) => {
      const card = document.createElement('li');
      const icon = document.createElement('span');
      const body = document.createElement('span');
      card.className = `vzy-package-card${item.isGift ? ' vzy-package-card--gift' : ''}`;
      icon.className = 'vzy-package-card__icon';
      body.className = 'vzy-package-card__body';
      icon.append(createPackageIcon(iconTypeFor(item.text)));
      if (item.isGift) {
        const badge = document.createElement('span');
        badge.className = 'vzy-package-card__badge';
        badge.textContent = root.dataset.packageGiftBadge || 'Inclus gratuit';
        body.append(badge);
      }
      body.append(document.createTextNode(item.text));
      card.append(icon, body);
      list.append(card);
    });

    packageContent.replaceChildren(intro, list);
    packageContent.dataset.vzyPackageEnhanced = 'true';
    return true;
  };

  const preparePackageTab = (root) => {
    const descriptionBody = root.querySelector('[data-vzy-description-body]');
    const packageButton = root.querySelector('[data-vzy-package-button]');
    const packagePanel = root.querySelector('[data-vzy-package-panel]');
    const packageContent = packagePanel?.querySelector('[data-vzy-package-content]');
    if (!descriptionBody || !packageButton || !packagePanel || !packageContent) {
      root.dataset.vzyPackageStatus = 'missing-elements';
      return;
    }

    let packageReady = false;

    if (cleanText(packageContent.textContent)) {
      root.dataset.vzyPackageStatus = 'metafield-source';
      packageReady = enhancePackageContent(root, packageContent);
      if (!packageReady) packageContent.replaceChildren();
    }

    if (!packageReady) {
      const candidates = [...descriptionBody.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong, b')];
      const sourceHeading = candidates.find((element) => isPackageHeading(element.textContent || ''));
      if (sourceHeading && descriptionBody.lastChild) {
        root.dataset.vzyPackageStatus = 'description-source';
        const followingHeadings = [...descriptionBody.querySelectorAll('h1, h2, h3, h4, h5, h6')]
          .filter((heading) => sourceHeading !== heading && Boolean(sourceHeading.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_FOLLOWING));
        const boundaryHeading = followingHeadings.find((heading) => {
          const headingText = heading.textContent || '';
          return !normalizeText(headingText) || !isPackageContinuationHeading(headingText);
        });
        const packageRange = document.createRange();
        packageRange.setStartBefore(sourceHeading);
        if (boundaryHeading) packageRange.setEndBefore(boundaryHeading);
        else packageRange.setEndAfter(descriptionBody.lastChild);
        packageContent.append(packageRange.extractContents());
        packageRange.detach();
        packageReady = enhancePackageContent(root, packageContent);
      } else {
        root.dataset.vzyPackageStatus = 'source-not-found';
      }
    }

    if (!packageReady) {
      root.dataset.vzyPackageStatus = `${root.dataset.vzyPackageStatus || 'unknown'}-invalid`;
      if (root.hasAttribute('data-vzy-accordion')) packagePanel.closest('details')?.remove();
      else { packageButton.remove(); packagePanel.remove(); }
      return;
    }

    root.dataset.vzyPackageStatus = 'ready';
  };

  const initProductTabs = (root) => {
    if (!root || controllers.has(root)) return;
    const abortController = new AbortController();
    const signal = abortController.signal;
    const frames = new Set();
    const scheduleFrame = (callback) => {
      const frame = window.requestAnimationFrame(() => {
        frames.delete(frame);
        if (!signal.aborted) callback();
      });
      frames.add(frame);
      return frame;
    };
    controllers.set(root, { abortController, frames });
    root.dataset.vzyTabsReady = 'true';
    root.classList.add('vzy-tabs-v2--ready');

    prepareDescriptionSmartModules(root);
    preparePackageTab(root);

    if (root.hasAttribute('data-vzy-accordion')) {
      const body = root.querySelector('[data-vzy-description-body]');
      if (body) {
        prepareDescriptionMediaFrames(body);
        prepareDescriptionImageNames(body);
        body.querySelectorAll('h2,h3,h4,h5,h6').forEach(heading => {
          if (cleanText(heading.textContent)) return;
          if (heading.querySelector('img,picture,video,iframe')) {
            const group = document.createElement('div');
            group.className = 'vzy-tabs-v2__media-group';
            while (heading.firstChild) group.appendChild(heading.firstChild);
            heading.replaceWith(group);
          } else heading.remove();
        });
      }
      root.classList.remove('vzy-tabs-v2--description-pending', 'vzy-tabs-v2--description-collapsed');
      root.classList.add('vzy-tabs-v2--description-expanded');
      const revealHash = () => {
        if (!location.hash) return;
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (!target || !root.contains(target)) return;
        for (let disclosure = target.closest('details'); disclosure && root.contains(disclosure); disclosure = disclosure.parentElement?.closest('details')) {
          disclosure.open = true;
        }
      };
      revealHash();
      window.addEventListener('hashchange', revealHash, { signal });
      return;
    }

    const nav = root.querySelector('[role="tablist"]');
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    if (!nav || !tabs.length || !panels.length) return;

    const updateNavScrollState = () => {
      const maxScroll = Math.max(0, nav.scrollWidth - nav.clientWidth);
      const isScrollable = maxScroll > 2;
      root.classList.toggle('vzy-tabs-v2--nav-scrollable', isScrollable);
      root.classList.toggle('vzy-tabs-v2--nav-at-start', !isScrollable || nav.scrollLeft <= 2);
      root.classList.toggle('vzy-tabs-v2--nav-at-end', !isScrollable || nav.scrollLeft >= maxScroll - 2);
    };

    const resetNavToStart = () => {
      nav.scrollTo({ left: 0, behavior: 'auto' });
      updateNavScrollState();
    };

    const centerTabInNav = (tab) => {
      if (nav.scrollWidth <= nav.clientWidth) return;
      const left = tab.offsetLeft - ((nav.clientWidth - tab.offsetWidth) / 2);
      nav.scrollTo({
        left: Math.max(0, left),
        behavior: window.matchMedia(REDUCED_MOTION).matches ? 'auto' : 'smooth'
      });
      scheduleFrame(updateNavScrollState);
    };

    let scheduleDescriptionCollapse = () => {};

    const activate = (tab, { focus = false, scroll = true } = {}) => {
      const controlledPanel = tab.getAttribute('aria-controls');

      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.dataset.vzyTabState = selected ? 'active' : 'inactive';
        item.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== controlledPanel;
      });

      if (controlledPanel?.endsWith('-description')) scheduleDescriptionCollapse();

      if (scroll) centerTabInNav(tab);
      if (focus) tab.focus({ preventScroll: true });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab), { signal });
      tab.addEventListener('keydown', (event) => {
        let nextTab;
        if (event.key === 'ArrowRight') nextTab = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') nextTab = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') nextTab = tabs[0];
        if (event.key === 'End') nextTab = tabs[tabs.length - 1];
        if (!nextTab) return;

        event.preventDefault();
        activate(nextTab, { focus: true });
      }, { signal });
    });

    nav.addEventListener('scroll', updateNavScrollState, { passive: true, signal });
    window.addEventListener('resize', updateNavScrollState, { passive: true, signal });
    window.addEventListener('pageshow', () => {
      const selectedTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      if (!selectedTab || selectedTab === tabs[0]) resetNavToStart();
      else centerTabInNav(selectedTab);
    }, { signal });

    const descriptionBody = root.querySelector('[data-vzy-description-body]');
    const descriptionPanel = descriptionBody?.closest('[role="tabpanel"]');
    const descriptionToggle = root.querySelector('[data-vzy-description-toggle]');
    const descriptionLabel = root.querySelector('[data-vzy-description-label]');
    const descriptionArrow = root.querySelector('[data-vzy-description-arrow]');
    let descriptionWasExpandedByUser = false;
    let syncDescriptionFocusability = () => {};

    const setDescriptionExpanded = (expanded, returnToPanel = false) => {
      root.classList.toggle('vzy-tabs-v2--description-collapsed', !expanded);
      root.classList.toggle('vzy-tabs-v2--description-expanded', expanded);
      descriptionToggle?.setAttribute('aria-expanded', String(expanded));
      if (descriptionLabel) {
        descriptionLabel.textContent = expanded ? 'Restrânge descrierea' : 'Vezi descrierea completă';
      }
      if (descriptionArrow) {
        descriptionArrow.textContent = expanded ? '↑' : '↓';
      }
      syncDescriptionFocusability(!expanded);

      if (returnToPanel && !expanded) {
        const descriptionTab = tabs.find((tab) => tab.getAttribute('aria-controls')?.endsWith('-description'));
        descriptionTab?.focus({ preventScroll: true });
        root.scrollIntoView({
          behavior: window.matchMedia(REDUCED_MOTION).matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    };

    if (descriptionBody && descriptionToggle) {
      const descriptionFocusables = () => [...descriptionBody.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]'
      )].filter((element) => element instanceof HTMLElement);

      const restoreFocusable = (element) => {
        if (!Object.prototype.hasOwnProperty.call(element.dataset, 'vzyOriginalTabindex')) return;
        const previous = element.dataset.vzyOriginalTabindex;
        if (previous === '__none__') element.removeAttribute('tabindex');
        else element.setAttribute('tabindex', previous);
        delete element.dataset.vzyOriginalTabindex;
      };

      syncDescriptionFocusability = (collapsed) => {
        const elements = descriptionFocusables();
        if (!collapsed) {
          elements.forEach(restoreFocusable);
          return;
        }
        const cutoff = descriptionBody.getBoundingClientRect().top + descriptionBody.clientHeight - 1;
        const measurements = elements.map((element) => {
          const rect = element.getBoundingClientRect();
          return { element, hiddenByCrop: rect.top >= cutoff || rect.bottom > cutoff + 1 };
        });
        measurements.forEach(({ element, hiddenByCrop }) => {
          if (!hiddenByCrop) {
            restoreFocusable(element);
            return;
          }
          if (!Object.prototype.hasOwnProperty.call(element.dataset, 'vzyOriginalTabindex')) {
            element.dataset.vzyOriginalTabindex = element.hasAttribute('tabindex')
              ? element.getAttribute('tabindex')
              : '__none__';
          }
          element.tabIndex = -1;
        });
      };

      const evaluateDescriptionCollapse = () => {
        if (descriptionPanel?.hidden) return;
        const collapseEnabled = root.dataset.vzyCollapseDescription === 'true';
        const minimumCollapseHeight = Number.parseFloat(
          getComputedStyle(root).getPropertyValue('--vzy-description-min-collapse-height')
        );
        const visibleHeightVar = window.matchMedia('(max-width: 749px)').matches ? '--vzy-description-visible-height-mobile' : '--vzy-description-visible-height';
        const visibleHeight = Number.parseFloat(getComputedStyle(root).getPropertyValue(visibleHeightVar)) || minimumCollapseHeight;
        const fullDescriptionHeight = descriptionBody.scrollHeight;
        const shouldCollapse = collapseEnabled
          && Number.isFinite(minimumCollapseHeight)
          && Number.isFinite(visibleHeight) && fullDescriptionHeight > visibleHeight + 1;
        root.classList.remove('vzy-tabs-v2--description-pending');
        if (!shouldCollapse) {
          root.style.removeProperty('--vzy-description-collapse-height');
          descriptionToggle.hidden = true;
          root.classList.add('vzy-tabs-v2--description-expanded');
          root.classList.remove('vzy-tabs-v2--description-collapsed');
          syncDescriptionFocusability(false);
          return;
        }
        root.style.setProperty(
          '--vzy-description-collapse-height',
          Math.round(visibleHeight) + 'px'
        );
        descriptionToggle.hidden = false;
        setDescriptionExpanded(descriptionWasExpandedByUser);
      };

      // Coalesce image, font and resize events into one layout measurement per frame.
      let descriptionCollapseFrame = 0;
      scheduleDescriptionCollapse = () => {
        if (descriptionCollapseFrame || signal.aborted || descriptionPanel?.hidden) return;
        descriptionCollapseFrame = scheduleFrame(() => {
          descriptionCollapseFrame = 0;
          evaluateDescriptionCollapse();
        });
      };

      scheduleDescriptionCollapse();
      descriptionBody.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', scheduleDescriptionCollapse, { once: true, signal });
      });
      document.fonts?.ready?.then(scheduleDescriptionCollapse).catch(() => {});
      window.addEventListener('resize', scheduleDescriptionCollapse, { passive: true, signal });

      descriptionToggle.addEventListener('click', () => {
        const expanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
        descriptionWasExpandedByUser = !expanded;
        setDescriptionExpanded(!expanded, expanded);
      }, { signal });

      descriptionBody.querySelectorAll('h2, h3, h4, h5, h6').forEach((heading) => {
        if (cleanText(heading.textContent)) return;
        if (heading.querySelector('img, picture, video, iframe')) {
          const mediaGroup = document.createElement('div');
          mediaGroup.className = 'vzy-tabs-v2__media-group';
          while (heading.firstChild) mediaGroup.appendChild(heading.firstChild);
          heading.replaceWith(mediaGroup);
        } else {
          heading.remove();
        }
      }, { signal });

      prepareDescriptionMediaFrames(descriptionBody);

      prepareDescriptionImageNames(descriptionBody);

      descriptionBody.addEventListener('focusin', (event) => {
        if (
          root.classList.contains('vzy-tabs-v2--description-collapsed')
          && event.target instanceof HTMLElement
          && event.target.getBoundingClientRect().top >= descriptionBody.getBoundingClientRect().top + descriptionBody.clientHeight - 1
        ) {
          setDescriptionExpanded(true);
        }
      });
    } else {
      root.classList.remove('vzy-tabs-v2--description-pending');
    }

    activate(tabs[0], { scroll: false });
    resetNavToStart();
    scheduleFrame(resetNavToStart);
  };

  const destroyProductTabs = (root) => {
    const controller = controllers.get(root);
    if (!controller) return;
    controller.abortController.abort();
    controller.frames.forEach((frame) => window.cancelAnimationFrame(frame));
    controller.frames.clear();
    controllers.delete(root);
    delete root.dataset.vzyTabsReady;
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initProductTabs(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initProductTabs);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.(ROOT_SELECTOR)) destroyProductTabs(event.target);
    event.target.querySelectorAll?.(ROOT_SELECTOR).forEach(destroyProductTabs);
  });
})();
